// components/PersonalMainTable.jsx
import React from 'react';
import { mainTableHeaders } from '../constants/personalConstants';
import '../StatisticaPersonal.css';

const PersonalMainTable = ({ data, onRowClick, loading }) => {
    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Завантаження даних...</p>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="no-data-message">
                Інформація не знайдена
            </div>
        );
    }

    const sortedData = data.sort((a, b) => {
        if (a.district > b.district) return 1;
        if (a.district < b.district) return -1;
        return 0;
    });

    return (
        <div className="table-container peronal-table">
            <div className="table-header">
                <p className="reg-title">
                    Інформація щодо працівників в садочках станом на {new Date().toLocaleDateString('uk-UK')}
                </p>
            </div>
            
            <div className="table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">№</th>
                            <th scope='col'>Район</th>
                            <th scope='col'>ЗДО</th>
                            <th scope="col" colSpan={3}>Технічні професії, штатних одиниць</th>
                            <th scope="col" colSpan={3}>Педагогічні професії, штатних одиниць</th>
                        </tr>
                        <tr>
                            <th scope="col" rowSpan={2}></th>
                            <th scope='col' rowSpan={2}></th>
                            <th scope='col' rowSpan={2}></th>
                            <th scope="col">чоловіків</th>
                            <th scope="col">жінок</th>
                            <th scope="col">загалом</th>
                            <th scope="col">чоловіків</th>
                            <th scope="col">жінок</th>
                            <th scope="col">загалом</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.map((item, i) => {
                            const { report, kindergartenId, kindergartenNumber } = item;
                            const { PR3301, PR3302, PR3101, PR3102 } = report || {};

                            const techMale = PR3301 - PR3302 || 0;
                            const techFemale = PR3302 || 0;
                            const techTotal = PR3301 || 0;
                            const pedMale = PR3101 - PR3102 || 0;
                            const pedFemale = PR3102 || 0;
                            const pedTotal = PR3101 || 0;

                            return (
                                <tr 
                                    key={i} 
                                    onClick={() => onRowClick(kindergartenId, kindergartenNumber)}
                                    className="clickable-row"
                                >
                                    <td>{i + 1}</td>
                                    <td>{item.district}</td>
                                    <td>{item.kindergartenNumber}</td>
                                    <td>{techMale}</td>
                                    <td>{techFemale}</td>
                                    <td>{techTotal}</td>
                                    <td>{pedMale}</td>
                                    <td>{pedFemale}</td>
                                    <td>{pedTotal}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PersonalMainTable;